const mapDiv = document.querySelectorAll('.location__map-init');

function init(el, mapLat, mapLng, mapPin, mapZoom, mapPopup, mapId) {
  // eslint-disable-next-line no-undef
  const map = L.map(mapId, {
    center: [mapLat, mapLng],
    zoom: mapZoom,
    scrollWheelZoom: false,
  });

  // eslint-disable-next-line no-undef
  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: '&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors',
  }).addTo(map);

  // eslint-disable-next-line no-undef
  const greenIcon = L.icon({
    iconUrl: mapPin,
    iconSize: [22, 30],
    iconAnchor: [11, 15],
  });

  // eslint-disable-next-line no-undef, new-cap
  const markers = new L.marker([mapLat, mapLng], {
    icon: greenIcon,
  }).addTo(map);

  // eslint-disable-next-line no-undef
  const popup = markers.bindPopup(mapPopup, {
    maxWidth: 250,
  });

  popup.openPopup();
}

Array.prototype.forEach.call(mapDiv, (el) => {
  const mapLat = el.getAttribute('data-lat');
  const mapLng = el.getAttribute('data-lng');
  const mapPin = el.getAttribute('data-pin');
  const mapZoom = el.getAttribute('data-zoom');
  const mapId = el.getAttribute('id');
  const mapPopup = el.getAttribute('data-popup');

  // eslint-disable-next-line no-unused-vars
  init(el, mapLat, mapLng, mapPin, mapZoom, mapPopup, mapId);
});
